// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDEBtI_8mzgSRhW1JQThqFK_M5-O98MW6o",
  authDomain: "national-transport-registery.firebaseapp.com",
  projectId: "national-transport-registery",
  storageBucket: "national-transport-registery.appspot.com",
  messagingSenderId: "892533988829",
  appId: "1:892533988829:web:7d7ed53a5c4435596aea34",
  measurementId: "G-LBCSS5925J"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const storage = getStorage(app)